import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#auto-quotebox-cta-app', App);
